import React, { Suspense } from 'react';
import { Box, Button } from '@mui/material';

import { LoadingScreen } from '~components/atoms/LoadingScreen';
import { LocalizationTypography } from '~components/organisms/localization';

type Props = {
  onRetry?: () => void;
};

const TenantUnavailableContent: React.FC<Props> = ({ onRetry }) => {
  const textId = onRetry
    ? 'app.tenantUnavailablePage.error'
    : 'app.tenantUnavailablePage.notAvailable';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '100dvh',
        backgroundColor: 'white',
        width: '100%',
        p: 2,
      }}
    >
      <LocalizationTypography
        textId={`${textId}.title`}
        defaultText={
          onRetry ? 'Something went wrong' : 'This site is not available'
        }
        variant="h6"
        textAlign="center"
        sx={{
          color: (theme) => theme.palette.neutral[900],
          marginBottom: 1,
        }}
      />
      <LocalizationTypography
        textId={`${textId}.description`}
        defaultText={
          onRetry
            ? 'We could not load this page. Please try again.'
            : 'Please check the address and try again.'
        }
        variant="body2"
        textAlign="center"
        sx={{
          color: (theme) => theme.palette.neutral[600],
          marginBottom: 3,
        }}
      />
      {onRetry && (
        <Button variant="outlined" color="inherit" onClick={onRetry}>
          <LocalizationTypography
            textId={`${textId}.retry`}
            defaultText="Try again"
            disableParentTypography
          />
        </Button>
      )}
    </Box>
  );
};

export const TenantUnavailablePage: React.FC<Props> = (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <TenantUnavailableContent {...props} />
  </Suspense>
);
